'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * BONO has given no approval and no testimonial; `_held/` is a Next.js
 * private folder, so nothing here renders until the directory is moved up
 * one level. Same mechanism as the stories legal took down in #200.
 *
 * CONFIRM BEFORE THE HOLD LIFTS: company facts come from HubSpot; the O-Brain page calls BONO its least-documented client, with no Linear issues and no meetings on file. Verify channels, what the agent handles, and whether B2B and consumer are one agent or two.
 *
 * No stats row and no results table: no figure exists for BONO anywhere,
 * and a placeholder would be an invented claim. Add the stats, the table and
 * the six-place number check from the customer-stories skill in the same
 * commit that lands cleared figures. */
const BONOCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="BONO"
        title={t.customerStories['bono_hero_title']}
        subtitle={t.customerStories['bono_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'BONO',
          customerName: 'BONO',
          company: t.customerStories['bono_company_description'],
          industry: t.customerStories['bono_industry'],
          websiteUrl: 'https://www.bonohealth.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['bono_location'],
            },
          ],
          keyResults: [
            t.customerStories['bono_key_result_1'],
            t.customerStories['bono_key_result_2'],
            t.customerStories['bono_key_result_3'],
            t.customerStories['bono_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['bono_intro']}</p>

        <h2>{t.customerStories['bono_challenge_title']}</h2>
        <p>{t.customerStories['bono_challenge_p1']}</p>
        <p>{t.customerStories['bono_challenge_p2']}</p>
        <p>{t.customerStories['bono_challenge_p3']}</p>

        <h2>{t.customerStories['bono_solution_title']}</h2>
        <p>{t.customerStories['bono_solution_p1']}</p>
        <p>{t.customerStories['bono_solution_p2']}</p>
        <p>{t.customerStories['bono_solution_p3']}</p>

        <h2>{t.customerStories['bono_impact_title']}</h2>
        <p>{t.customerStories['bono_impact_p1']}</p>
        <p>{t.customerStories['bono_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default BONOCaseStudy;
